/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteLifeskillId } from '../fn/life-skill/delete-lifeskill-id';
import { DeleteLifeskillId$Params } from '../fn/life-skill/delete-lifeskill-id';
import { getLifeskill$Json } from '../fn/life-skill/get-lifeskill-json';
import { GetLifeskill$Json$Params } from '../fn/life-skill/get-lifeskill-json';
import { getLifeskill$Plain } from '../fn/life-skill/get-lifeskill-plain';
import { GetLifeskill$Plain$Params } from '../fn/life-skill/get-lifeskill-plain';
import { getLifeskillId$Json } from '../fn/life-skill/get-lifeskill-id-json';
import { GetLifeskillId$Json$Params } from '../fn/life-skill/get-lifeskill-id-json';
import { getLifeskillId$Plain } from '../fn/life-skill/get-lifeskill-id-plain';
import { GetLifeskillId$Plain$Params } from '../fn/life-skill/get-lifeskill-id-plain';
import { Lifeskill } from '../models/lifeskill';
import { LifeskillPagedResult } from '../models/lifeskill-paged-result';
import { postLifeskill$Json } from '../fn/life-skill/post-lifeskill-json';
import { PostLifeskill$Json$Params } from '../fn/life-skill/post-lifeskill-json';
import { postLifeskill$Plain } from '../fn/life-skill/post-lifeskill-plain';
import { PostLifeskill$Plain$Params } from '../fn/life-skill/post-lifeskill-plain';
import { putLifeskillId } from '../fn/life-skill/put-lifeskill-id';
import { PutLifeskillId$Params } from '../fn/life-skill/put-lifeskill-id';

@Injectable({ providedIn: 'root' })
export class LifeSkillService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getLifeskill()` */
  static readonly GetLifeskillPath = '/lifeskill';

  /**
   * Get all Lifeskill.
   *
   * Get all Lifeskill
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLifeskill$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLifeskill$Plain$Response(params?: GetLifeskill$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<LifeskillPagedResult>> {
    const obs = getLifeskill$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all Lifeskill.
   *
   * Get all Lifeskill
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLifeskill$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLifeskill$Plain(params?: GetLifeskill$Plain$Params, context?: HttpContext): Observable<LifeskillPagedResult> {
    const resp = this.getLifeskill$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<LifeskillPagedResult>): LifeskillPagedResult => r.body)
    );
  }

  /**
   * Get all Lifeskill.
   *
   * Get all Lifeskill
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLifeskill$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLifeskill$Json$Response(params?: GetLifeskill$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<LifeskillPagedResult>> {
    const obs = getLifeskill$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all Lifeskill.
   *
   * Get all Lifeskill
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLifeskill$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLifeskill$Json(params?: GetLifeskill$Json$Params, context?: HttpContext): Observable<LifeskillPagedResult> {
    const resp = this.getLifeskill$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<LifeskillPagedResult>): LifeskillPagedResult => r.body)
    );
  }

  /** Path part for operation `postLifeskill()` */
  static readonly PostLifeskillPath = '/lifeskill';

  /**
   * Create a Lifeskill.
   *
   * Create a Lifeskill
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postLifeskill$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postLifeskill$Plain$Response(params?: PostLifeskill$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Lifeskill>> {
    const obs = postLifeskill$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a Lifeskill.
   *
   * Create a Lifeskill
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postLifeskill$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postLifeskill$Plain(params?: PostLifeskill$Plain$Params, context?: HttpContext): Observable<Lifeskill> {
    const resp = this.postLifeskill$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Lifeskill>): Lifeskill => r.body)
    );
  }

  /**
   * Create a Lifeskill.
   *
   * Create a Lifeskill
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postLifeskill$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postLifeskill$Json$Response(params?: PostLifeskill$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Lifeskill>> {
    const obs = postLifeskill$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a Lifeskill.
   *
   * Create a Lifeskill
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postLifeskill$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postLifeskill$Json(params?: PostLifeskill$Json$Params, context?: HttpContext): Observable<Lifeskill> {
    const resp = this.postLifeskill$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Lifeskill>): Lifeskill => r.body)
    );
  }

  /** Path part for operation `getLifeskillId()` */
  static readonly GetLifeskillIdPath = '/lifeskill/{id}';

  /**
   * Get a Lifeskill by id.
   *
   * Get a Lifeskill by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLifeskillId$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLifeskillId$Plain$Response(params: GetLifeskillId$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Lifeskill>> {
    const obs = getLifeskillId$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a Lifeskill by id.
   *
   * Get a Lifeskill by id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLifeskillId$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLifeskillId$Plain(params: GetLifeskillId$Plain$Params, context?: HttpContext): Observable<Lifeskill> {
    const resp = this.getLifeskillId$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Lifeskill>): Lifeskill => r.body)
    );
  }

  /**
   * Get a Lifeskill by id.
   *
   * Get a Lifeskill by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLifeskillId$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLifeskillId$Json$Response(params: GetLifeskillId$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Lifeskill>> {
    const obs = getLifeskillId$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a Lifeskill by id.
   *
   * Get a Lifeskill by id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLifeskillId$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLifeskillId$Json(params: GetLifeskillId$Json$Params, context?: HttpContext): Observable<Lifeskill> {
    const resp = this.getLifeskillId$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Lifeskill>): Lifeskill => r.body)
    );
  }

  /** Path part for operation `putLifeskillId()` */
  static readonly PutLifeskillIdPath = '/lifeskill/{id}';

  /**
   * Update a Lifeskill.
   *
   * Update a Lifeskill
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putLifeskillId()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putLifeskillId$Response(params: PutLifeskillId$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = putLifeskillId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a Lifeskill.
   *
   * Update a Lifeskill
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putLifeskillId$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putLifeskillId(params: PutLifeskillId$Params, context?: HttpContext): Observable<void> {
    const resp = this.putLifeskillId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteLifeskillId()` */
  static readonly DeleteLifeskillIdPath = '/lifeskill/{id}';

  /**
   * Delete a Lifeskill.
   *
   * Delete a Lifeskill
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteLifeskillId()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLifeskillId$Response(params: DeleteLifeskillId$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteLifeskillId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a Lifeskill.
   *
   * Delete a Lifeskill
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteLifeskillId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLifeskillId(params: DeleteLifeskillId$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteLifeskillId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
